import CSRList from './List'
import CSRShow from './Show'
import CSRCreate from './Create'
import CSREdit from './Edit'

const CSRResource = {
  list: CSRList,
  show: CSRShow,
  create: CSRCreate,
  edit: CSREdit,
}

export default CSRResource
